import React, { useState, useEffect } from "react";
import SecurityIcon from "../../assets/png/security.png";
import AuthIcon from "../../assets/png/authenticator-icon.png";
import NactLogo from "../../assets/png/nact-logo.png";

// import "./Twofa.css";

import CommonModal from "../Modals/CommonModal";
import { useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";

const PageTwoFa = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [inputValues, setInputValues] = useState("");
  // console.log("inputValues", inputValues);

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );

  const [twofa, settwofa] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.twofa
  );

  useEffect(() => {
    if (modalShow) {
      setTimeout(function () {
        navigate("/disable-twofa");
        setModalShow(false);
      }, 2000);
    }
  }, [modalShow]);

  const checkPin = () => {
    const inputElements = [...document.querySelectorAll("input.code-input")];
    inputElements.forEach((ele, index) => {
      ele.addEventListener("keydown", (e) => {
        // if the keycode is backspace & the current field is empty
        // focus the input before the current. Then the event happens
        // which will clear the "before" input box.
        if (e.keyCode === 8 && e.target.value === "")
          inputElements[Math.max(0, index - 1)].focus();
      });
      ele.addEventListener("input", (e) => {
        // take the first character of the input
        // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
        // but I'm willing to overlook insane security code practices.
        const [first, ...rest] = e.target.value;
        e.target.value = first ?? ""; // first will be undefined when backspace was entered, so set the input to ""
        const lastInputBox = index === inputElements.length - 1;
        const didInsertContent = first !== undefined;
        if (didInsertContent && !lastInputBox) {
          // continue to input the rest of the string
          inputElements[index + 1].focus();
          inputElements[index + 1].value = rest.join("");
          inputElements[index + 1].dispatchEvent(new Event("input"));
        }

        const code = inputElements.map(({ value }) => value).join("");
        setInputValues(code);
      });
    });
  };

  useEffect(() => {
    checkPin();
  }, [inputValues]);

  const [twoFaCode, setTwoFaCode] = useState({
    twoFaCode1: "",
    twoFaCode2: "",
    twoFaCode3: "",
    twoFaCode4: "",
    twoFaCode5: "",
    twoFaCode6: "",
  });
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const twoFaChangeHandler = (e) => {
    const { name, value } = e.target;
    setTwoFaCode((preVal) => {
      return {
        ...preVal,
        [name]: value,
      };
    });
  };
  const submitTwoFaReq = async () => {
    try {
      if (inputValues.length < 6) {
        setError(true);
        setErrorMessage("Fill all fields");
        setTimeout(() => {
          setErrorMessage("");
          setError(false);
        }, 5000);
        return;
      }
      const submitTwaFa = await servicePost(
        "api/v1/admin/twofactorverified",
        {
          user: user?.Username,
          // token: `${twoFaCode.twoFaCode1}${twoFaCode.twoFaCode2}${twoFaCode.twoFaCode3}${twoFaCode.twoFaCode4}${twoFaCode.twoFaCode5}${twoFaCode.twoFaCode6}`,
          token: inputValues,
        },
        notification,
        authToken
      );

      if (submitTwaFa.data === true) {
        localStorage.setItem("isTwofa", true);
        //  window.location.reload();
        navigate("/");
      } else {
        setError(true);
        setErrorMessage("Authentication code expired.");
        setTimeout(() => {
          setErrorMessage("");
          setError(false);
        }, 5000);
      }
    } catch (error) {
      setError(true);
      setErrorMessage("Something went wrong.");
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
      }, 5000);
    }
  };

  const goToDashboard = () => {
    navigate("/");
  };

  return (
    <>
      <CommonModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        type="2F Authentication successfully done"
      />

      <div className="twofa-guide-wrapper">
        <div className="container">
          <div className="twofa-header kyc-verification-header">
            <div className="twofa-guide-header-content">
              <img src={AuthIcon} alt="icon" />
              <h3 className="twofa-desktop"> Two-Factor Authentication</h3>
              <h3 className="twofa-mobile-header"> 2F Authentication</h3>
            </div>

            <img src={NactLogo} alt="logo" />
          </div>

          <div className="twofa-enable-wrapper">
            <div className="twofa-backup-secret">
              <p className="twofa-auth-code-text">
                Enter the 6-digit Google Authenticator code
              </p>
            </div>

            <div className="security-code-text auth-input">
              <h3> Authentication Code</h3>

              <div className="pin-code-twofa">
                <input
                  className="code-input"
                  type="number"
                  maxLength="1"
                  name="twoFaCode1"
                  onChange={twoFaChangeHandler}
                  // value={twoFaCode.twoFaCode1}
                  autoFocus
                />
                <input
                  className="code-input"
                  type="number"
                  maxLength="1"
                  name="twoFaCode2"
                  onChange={twoFaChangeHandler}
                  // value={twoFaCode.twoFaCode2}
                />
                <input
                  className="code-input"
                  type="number"
                  maxLength="1"
                  name="twoFaCode3"
                  onChange={twoFaChangeHandler}
                  // value={twoFaCode.twoFaCode3}
                />
                <input
                  className="code-input"
                  type="number"
                  maxLength="1"
                  name="twoFaCode4"
                  onChange={twoFaChangeHandler}
                  // value={twoFaCode.twoFaCode4}
                />
                <input
                  className="code-input"
                  type="number"
                  maxLength="1"
                  name="twoFaCode5"
                  onChange={twoFaChangeHandler}
                  // value={twoFaCode.twoFaCode5}
                />
                <input
                  className="code-input"
                  type="number"
                  maxLength="1"
                  name="twoFaCode6"
                  onChange={twoFaChangeHandler}
                  // value={twoFaCode.twoFaCode6}
                />
              </div>
              <div className="input-error-box">
                {error ? <div className="error-msg">{errorMessage}</div> : ""}
              </div>
            </div>

            <div className="twofa-footer">
              <div className="twofa-security-wrapper">
                <div className="twofa-security-wrap">
                  <img src={SecurityIcon} alt="icon" />
                  <p>
                    To log in, open your Google Authenticator app on your phone
                    and retrieve the six-digit code. Enter the code in the
                    provided field on this page to complete the login process
                  </p>
                </div>
              </div>

              <div className="twofa-guide-button">
                <button
                  onClick={() => submitTwoFaReq()}
                  //onClick={goToDashboard}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>

          {twofa !== true ? (
            <div className="twofa-icons">
              <div className="icons"></div>
              <div className="icons"></div>
              <div className="icons active-icon"></div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

export default PageTwoFa;
